// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--1ff_5","input":"styles-module--input--mY4Nl","button":"styles-module--button--dedGT"};